module.exports = __webpack_public_path__ + "img/pzzx.1236332b.svg";